import React from "react";
import notFound from "../../assets/notFound.svg";
import Flexbox from "flexbox-react";


const BlankPage = ({ title, description }) => {
  return (
    <Flexbox flexDirection="column" justifyContent="center" alignItems="center" className="push-10-t p-6">
      
        <img src={notFound} alt="Empty State" className="w-38 h-38 mb-4 mt-4" />
        <h3 className=" .bp5-text-large font-semibold text-gray-600">{title}</h3>
        <p className="text-gray-500 max-w-md">{description}</p>
      
    </Flexbox>
  );
};

export default BlankPage;
